import * as yup from "yup";

import { CustomerSummaryData } from "./customer-model";
import { useFormik } from "formik";
import { useTranslation } from "next-i18next";

/**
 * Manages form data for customer data step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useCustomerSummaryFormik(
  onNext: (data: CustomerSummaryData) => void
) {
  const { t } = useTranslation();
  const messageRequired = t("common:common.required");


  const validationSchema = yup.object().shape({
    agreeToTerms: yup.boolean().oneOf([true], messageRequired),
    accessToken: yup.string().required(messageRequired),
  });

  const formik = useFormik<CustomerSummaryData>({
    initialValues: {
      agreeToTerms: false,
      accessToken: "",
    },
    validationSchema: validationSchema,
    // use handleSubmission instead
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}
